import { render, staticRenderFns } from "./AlarmBin.vue?vue&type=template&id=85b897a8&scoped=true"
import script from "./AlarmBin.vue?vue&type=script&lang=ts"
export * from "./AlarmBin.vue?vue&type=script&lang=ts"
import style0 from "./AlarmBin.vue?vue&type=style&index=0&id=85b897a8&prod&lang=css"
import style1 from "./AlarmBin.vue?vue&type=style&index=1&id=85b897a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85b897a8",
  null
  
)

export default component.exports